import styled from 'styled-components';
import { S_FlexBox } from '../../../style/FlexBox.style';

export const S_OneDayListtWrapper = styled(S_FlexBox)`
  width: 90%;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;
